import { periodFormat } from 'utils/common';

export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      sentimentDate: periodFormat(filter.sentimentDate)
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
